import { coreAPI } from "../../axios";


export const actions = {
    GetAgency(){
        return coreAPI.get("Agency/GetAllAgencies");
    },
    GetSingleAgency(context, data){
        return coreAPI.get(`Agency/${data}`);
    },
    UpdateAgency(context, data){
        return coreAPI.put(`Agency/${data.id}`, data);
    },
    DeleteAgency(context, data){
        return coreAPI.delete(`Agency/${data}`);
    },
    CreateAgency(context, data){
        return coreAPI.post(`Agency/CreateAgency`, data);
    }
}